import { AlertType } from "features/shared/alerts/enums/alertType";
import { ContractingState } from "features/contracting/enums/contractingState";
import { ContractingInfoSubDialogProps } from "features/contracting/models/ContractingInfoSubDialogProps";
import { redirectToUrl } from "features/shared/helpers/urlHelper";
import UserManager from "infrastructure/oidc/UserManager";

export interface InvalidContractingLinkDialogConfig {
  titleKey: string;
  props: ContractingInfoSubDialogProps;
}

/**
 * Maps a contractingStateCode (actual ContractingState enum value) to the
 * corresponding i18next translation key used in the dialog message body.
 *
 * Group A – sent for processing (ContractingComplete, DocumentSentToSignOK, SentToFlexiOK)
 *   → linkInvalidSentMessage
 *
 * Group B – cancelled (Cancelled)
 *   → linkInvalidCancelledMessage
 *
 * Group C – error states, unknown state, null
 *   → linkInvalidOtherMessage
 */
export const getInvalidLinkMessageKeyFromStateCode = (
  stateCode: string | null | undefined
): string => {
  const groupASentStates: string[] = [
    ContractingState.ContractingComplete,
    ContractingState.DocumentSentToSignOK,
    ContractingState.SentToFlexiOK,
  ];
  const groupBCancelledStates: string[] = [
    ContractingState.Cancelled,
  ];

  if (stateCode != null && groupASentStates.includes(stateCode)) return "linkInvalidSentMessage";
  if (stateCode != null && groupBCancelledStates.includes(stateCode)) return "linkInvalidCancelledMessage";
  return "linkInvalidOtherMessage";
};

export const getStateCodeFromValidationProblem = (
  data: any
): string | undefined => {
  const errors = data?.errors;
  if (!errors) return undefined;

  const firstError = Object.values<string[]>(errors)[0];
  return Array.isArray(firstError) ? firstError[0] : undefined;
};

export const getInvalidContractingLinkDialog = (
  stateCode: string | null | undefined,
  newContractingUrl: string
): InvalidContractingLinkDialogConfig => {
  const messageKey = getInvalidLinkMessageKeyFromStateCode(stateCode);

  return {
    titleKey: "linkInvalidTitle",
    props: {
      type: AlertType.Warning,
      message: messageKey,
      primaryBtn: {
        text: "newContracting",
        action: () => redirectToUrl(newContractingUrl),
      },
      secondaryBtn: {
        text: "login",
        action: () => UserManager.signinRedirect(),
      },
    },
  };
};
